import { Account } from '../account/account.model';
import { createSelector } from 'reselect';
import { Job } from './job.model';
import { RestrictedAccountObjectQueryFactory } from '../restricted-account-object/restricted-account-object.query-factory';
import { IJobFilters, State } from './job.reducer';
import { listSelector } from '../query-facade';
import { VasState } from '../../store/store-type';
import { Field } from '../field/field.model';

export class JobQueryFactory extends RestrictedAccountObjectQueryFactory<Job, IJobFilters> {

    protected _inlined: listSelector<Job>;
    protected _byActiveAccountInlined: listSelector<Job>;

    get inlined(): listSelector<Job> {
        return this.items;
    }

    get byActiveAccountInlined(): listSelector<Job> {

        if (!this._byActiveAccountInlined) {

            this._byActiveAccountInlined = createSelector(this.inlined, this.selectedAccount,
                (jobs, account: Account) => {
                    if (!account) return [];
                    return jobs.filter(job => job.account === account.id);
                });
        }

        return this._byActiveAccountInlined;
    }

    get state2(): (state: VasState) => State {
        return state => state.job;
    }

    get total(): (state: VasState) => number {
        return createSelector(this.state2, state => state.total);
    }

    get canLoadMore(): (state: VasState) => boolean {
        return createSelector(this.total, this.ids, (total: number, ids: Array<string>) => {
            return total > ids.length;
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.queries.ts